<template>
  <product-benefits-item-component-fi />
</template>

<script setup lang="ts">
import ProductBenefitsItemComponentFi from '@/components/product-benefits-fi/ProductBenefitsItemComponentFi.vue';
import type { ProductBenefitsItemFiFields } from '@/generated/fields';

defineProps<{
  fields?: ProductBenefitsItemFiFields;
}>();
</script>

<style scoped src="./product-benefits-item-fi" />
